import locationHelper from '../helpers/location'

export default {
    methods: locationHelper
}
